import React, { Fragment, useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import cn from 'classnames'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

import { Checkbox } from 'Components/Form/Checkbox'
import { SnackBarContext } from 'Components/SnackBar'

import { CAMPAIGN_INTERNAL_STATUSES } from 'shared/constants'

import { approveCodes } from '../../gql/approveClientCodes'
import EmailModal from '../Popups/EmailPopup/index.js'
import styles from './styles'
import { insertCampaignLogs } from '../../../../../../Logs/campaign/gql'
import { CAMPAIGN_LOG_ENUM_TYPES } from '../../../../../../shared/constants'

const AdminTool = ({
  classes,
  isButtonsDisabled,
  campaignStatus,
  setInternalStatus,
}) => {
  const { campaignId } = useParams()
  const runSnackBar = useContext(SnackBarContext)

  let icon = null
  let isAccepted = false
  if (
    campaignStatus === CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF ||
    campaignStatus === CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF ||
    campaignStatus === CAMPAIGN_INTERNAL_STATUSES.PAYMENT ||
    campaignStatus === CAMPAIGN_INTERNAL_STATUSES.ACTIVE ||
    campaignStatus === CAMPAIGN_INTERNAL_STATUSES.COMPLETED
  ) {
    icon = <CheckCircleIcon style={{ color: '#3EB034' }} />
    isAccepted = true
  }
  if (campaignStatus === CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW) {
    icon = <WarningRoundedIcon style={{ color: '#FDB600' }} />
  }

  const [shouldSendEmail, setShouldSendEmail] = useState(false)
  const [
    isDeclineSendMessagePopupOpen,
    setIsDeclineSendMessagePopupOpen,
  ] = useState(false)
  const isCheckBoxDisabled = true

  const onApprove = async () => {
    const response = await approveCodes({
      campaignId: campaignId,
      isSendEmail: shouldSendEmail,
    })
    const result = await response.json()
    const responseInfo = result.data.approveCodes
    setInternalStatus(responseInfo.internalStatus)
    await insertCampaignLogs([
      {
        campaignId,
        type: CAMPAIGN_LOG_ENUM_TYPES.APPROVE_CODES,
        additionalInfo: shouldSendEmail ? 'with' : 'without',
      },
    ])
    if (responseInfo.success) {
      runSnackBar({
        type: 'success',
        msg: `Codes successfully approved.`,
      })
    } else {
      runSnackBar({
        type: 'error',
        msg: `${responseInfo.error}.`,
      })
    }
  }

  return (
    <Fragment>
      <EmailModal
        isOpen={isDeclineSendMessagePopupOpen}
        onCancel={() => setIsDeclineSendMessagePopupOpen(false)}
      />
      <div className={classes.adminTool}>
        <div className={classes.adminToolHeader}>Admin tool</div>
        <div className={classes.adminToolBlock}>
          <div className={classes.blockHeader}>
            <div>Review client data</div>
            {icon}
          </div>
          <div className={classes.blockButtons}>
            <Button
              className={cn(classes.button, classes.activeButton)}
              variant="outlined"
              disabled={isButtonsDisabled}
              onClick={onApprove}
            >
              Approve
            </Button>
          </div>
          <div
            className={cn(
              classes.checkbox,
              isCheckBoxDisabled ? classes.disabled : '',
            )}
          >
            <Checkbox
              label={'Send Approval Email'}
              shouldListenToInputValue
              input={{
                value: shouldSendEmail,
                onChange: () => setShouldSendEmail(!shouldSendEmail),
                disabled: isCheckBoxDisabled,
              }}
            />
          </div>
          {isAccepted ? (
            <div className={classes.approveDeclineInfo}>Approved</div>
          ) : null}
        </div>
      </div>
    </Fragment>
  )
}

export default withStyles(styles)(AdminTool)
